import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-door",
  "use": "icon-si-glyph-door-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-door\" id=\"icon-si-glyph-door\"><title>1144</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(4.000000, 0.000000)\" fill=\"#434343\"><path d=\"M0.083,0.041 L7.042,2.708 L7.042,14.792 L0.333,13.083 L0.125,13.917 L7.928,15.917 L7.928,13.875 L9.896,13.874 L9.896,0.041 L0.083,0.041 Z\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"8\" width=\"0.875\" height=\"0.875\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-door.svg
// module id = D90o
// module chunks = 62